import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import OutlinedButton from 'components/OutlinedButton';
import HonorRollListItem from './HonorRollListItem';
import { toScreen } from 'utils/media-query/responsive.util';
import { desktopFirstV3 } from 'style/breakpointsv3';

const Wrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 24px;

  ${toScreen(desktopFirstV3.lg)} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  ${toScreen(desktopFirstV3.md)} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${toScreen(desktopFirstV3.sm)} {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const HonorRollList = ({ data, loading, total, loadMore }) => {
  return (
    <>
      <Wrapper>
        {data.map((item, index) => (
          <HonorRollListItem key={index} {...item} index={index} />
        ))}
      </Wrapper>
      {total > data.length && (
        <LoadMoreWrapper>
          <OutlinedButton onClick={loadMore} loading={loading}>
            Hiển thị thêm
          </OutlinedButton>
        </LoadMoreWrapper>
      )}
    </>
  );
};

export default HonorRollList;
